var React = require('react');

function Patient (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z","key":1})]);
}

Patient.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Patient;

Patient.default = Patient;



//////////////////
// WEBPACK FOOTER
// /home/winc/bitbucket/iol2/sandbox-manager-v3/node_modules/svg-react-loader/lib/loader.js?name=Patient!./src/assets/icons/baseline-info.svg
// module id = 671
// module chunks = 1